import { formAnatomy as parts } from '@chakra-ui/anatomy'
import { ComponentStyleConfig } from '@chakra-ui/react'
import type {
  PartsStyleFunction,
  SystemStyleFunction
} from '@chakra-ui/theme-tools'

const baseStyleRequiredIndicator: SystemStyleFunction = () => {
  return {
    // This is an intentional override from Design team,
    // no space between astrix and label and no red color.
    marginStart: 0,
    color: 'inherit'
  }
}
const baseStyle: PartsStyleFunction<typeof parts> = (props) => ({ requiredIndicator: baseStyleRequiredIndicator(props) })

export const FormTheme: ComponentStyleConfig = { baseStyle }
